@if (simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-cat
    >
  </app-cat>
}

@if (statesService.states.drinking
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-water
    >
  </app-water>
}

@if (statesService.states.eating
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.drinking
  && !statesService.states.playing
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-eating
    >
  </app-eating>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Angel'
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-rod
    >
  </app-rod>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Wollknäuel'
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-wool
    >
  </app-wool>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Aufziehmaus'
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-mouse
    >
  </app-mouse>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Streicheln'
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.cleaningCatToilet
  && !statesService.states.showPills) {
  <app-stroking
    >
  </app-stroking>
}

@if (statesService.states.cleaningCatToilet
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.showPills
  && !statesService.states.playing) {
  <app-cleaning
    >
  </app-cleaning>
}

@if (statesService.states.showPills
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.washing
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.cleaningCatToilet) {
  <app-pills
    >
  </app-pills>
}

@if (statesService.states.washing
  && simulation.pet.life > 0
  && !statesService.states.showPills
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.wiping) {
  <app-washing
    >
  </app-washing>
}
